module.exports = __webpack_public_path__ + "static/media/TUNE_3080.4c2a4b4c.jpg";